// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__1AWLi","title":"style_title__1VNL7","body":"style_body__2LL-9"};